export function Tabs<T extends string>({ options, value, onChange, label }: {
  options: ReadonlyArray<readonly [T, string]>;
  value: T;
  onChange: (v: T) => void;
  label?: string;
}) {
  return (
    <div className="tabs" role="tablist" aria-label={label}>
      {options.map(([k, l]) => (
        <button key={k} type="button" role="tab" aria-selected={k === value} onClick={() => onChange(k)}>{l}</button>
      ))}
    </div>
  );
}
